import React from "react";
import Modal from "../../../../Components/Modal";
import { Text } from "../../../../Components/Text";
import TextInput from "../../../../Components/Inputs/Text";
import Textarea from "../../../../Components/Inputs/Textarea";
import Button from "../../../../Components/Button";
import Grid from "../../../../Components/Grid";
import Spacer from "../../../../Components/Spacer";

import css from "../styles.styl";

export const EditProjectModal = ({ isOpen, onClose, onSubmit, project }) => {
	const { state, updateForm } = project;

	const handleSubmit = () => {
		onSubmit(state);
		onClose();
	};

	if (!isOpen) return null;

	const content = (
		<>
			<div>
				<Text size={2} weight="medium" as="label">
					Decision Project Name
				</Text>
				<TextInput value={state.name} onChange={(value) => updateForm({ name: value })} />
			</div>

			<Spacer size={2} />

			<div>
				<Text size={2} weight="medium" as="label">
					Decision Project Description
				</Text>
				<Textarea value={state.description} onChange={(value) => updateForm({ description: value })} />
			</div>
		</>
	);

	const buttons = (
		<div className={css.modalButtons}>
			<Grid columns={["1fr"]}>
				<div className={css.modalButton}>
					<Button version={2} color="green" onClick={handleSubmit}>
						Update
					</Button>
				</div>
			</Grid>
		</div>
	);

	return <Modal size="large" content={content} buttons={buttons} handleClose={onClose} />;
};
